import { render, staticRenderFns } from "./CreateAddressBook.vue?vue&type=template&id=002d2b5e"
import script from "./CreateAddressBook.vue?vue&type=script&lang=js"
export * from "./CreateAddressBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports